import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { Moment } from 'moment';
import { Observable, Subscription, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CONFIG } from '../../../../core/config/config';
import { DoctorSearchResultModel, TimeSlot } from '../../../../models/doctor-search-result.model';
import { ApiService, AuthService, LanguageService, UserService } from '../../../../services';
import { DoctorService } from '../../../../services/doctor.service';
import { PageManipulationUtilsService } from '../../../../services/page-manipulation-utils.service';
import { RequestDoctorDialogComponent } from '../../../dialogs/request-doctor-dialog/request-doctor-dialog.component';
import { LoadingService } from '../../../services/loading.service';
import { DoctorSlotDialogComponent } from '../../doctor-slot-dialog/doctor-slot-dialog.component';
import { ConfirmDialogComponent } from "../../../../components";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-time-slot',
  templateUrl: './time-slot.component.html',
  styleUrls: ['./time-slot.component.scss']
})
export class TimeSlotComponent implements OnInit, OnChanges, OnDestroy {
  @Input() doctor: DoctorSearchResultModel;
  @Input() renderDates: Moment[];
  @Input() selectedServiceType: number;
  @Input() selectedSpeciality: number;
  @Input() isPublicProfile: boolean = false;
  @Input() doctorClicked: Observable<void>;
  @Input() id: any;
  @Output() onServiceTypeSelect = new EventEmitter();
  @Output() onSpecialtyChange = new EventEmitter();
  @Output() navigateToSelectedDoctor = new EventEmitter();
  @Output() navigateToClosestAvailableDate = new EventEmitter<{ specialtyId: number, date: number, keyword?: number }>();
  @Output() searchDateChange = new EventEmitter<number>();
  @Output() reinitializeSearch = new EventEmitter<any>();
  @Output() doctorUpdated = new EventEmitter<any>();
  canSlideLeft = false;
  canSlideRight = true;
  specialityFormControl = new UntypedFormControl();
  public cLang = CONFIG.LANGS.LANG_DATA.DEFAULT_LANG;
  allSlots = 5;
  public toggleSlots: boolean = false;
  renderDatesFilter: Moment[] = [];

  maxDate: Moment;
  


  @ViewChild('timeTableWrapper') timeTableWrapper: ElementRef<HTMLDivElement>;
  serviceTypes: any[];
  serviceTypeControl = new UntypedFormControl();
  doctorSlotsAvailable = false;
  doctorRequested: boolean = false;
  private eventsSubscription: Subscription;
  private currentUser: any;
  public selectedLanguage = localStorage.getItem('CurLang') || 'ka';
  isInsuranceBubble = false;
  newDoctor: DoctorSearchResultModel;

  constructor(
    public LS: LanguageService,
    private loadingService: LoadingService,
    private doctorService: DoctorService,
    private userService: UserService,
    public API: ApiService,
    public Auth: AuthService,
    private dialog: MatDialog,
    public router: Router,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute) {
    this.maxDate = moment();
    this.maxDate.date(this.maxDate.date() + 28);
  }

  ngOnInit() {
    this.userService.getUser
      .subscribe(
        (user: any) => {
          this.currentUser = user;
        }
      );
    this.cLang = this.LS.getLang();
    if (this.doctor) {

      this.specialityFormControl.setValue(this.doctor.specialties.length > 0 ? this.doctor.specialties[0]?.specialtyId : this.doctor.specialtiesAll[0]?.specialtyId);
    }
    if (this.isPublicProfile) {
      this.initServiceTypes(this.id);
    }
    this.checkForServiceTypeChanges();
    this.checkForSpecialtyChange();
    this.userService.getUser
      .subscribe(
        (user: any) => {
          if (user) {
            this.currentUser = user;
          }
        }
      );

    this.setInsuranceStatus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.doctorSlotsAvailable = false;
    if (this.doctorClicked) {
      this.eventsSubscription = this.doctorClicked.subscribe(() => {
        this.navigateToSelectedDoctor.emit({
          selectedSpecialty: this.specialityFormControl.value
        });
      });
    }
    if (this.doctor) {
      this.specialityFormControl.setValue(this.doctor.specialties.length > 0 ? this.doctor.specialties[0]?.specialtyId : this.doctor.specialtiesAll[0]?.specialtyId, { emitEvent: false });
      for (let slot in this.doctor.timeSlotDTOs) {
        this.doctor.timeSlotDTOs[slot].forEach(timeSlot => {
          if (timeSlot.slotId) {
            this.doctorSlotsAvailable = true;
          }
        });
      }
    }
  }

  ngOnDestroy(): void {
    if (this.eventsSubscription) {
      this.eventsSubscription.unsubscribe();
    }
  }

  checkForServiceTypeChanges() {
    this.serviceTypeControl.valueChanges
      .subscribe(
        (result) => {
          this.drawNewOne(result)
        });
  }

  drawNewOne(result) {
    this.onServiceTypeSelect.emit(result);
    setTimeout(() => {
      if (this.timeTableWrapper) {
        this.timeTableWrapper.nativeElement.style.right = 0 + 'px';
      }
      this.canSlideLeft = false;
      this.canSlideRight = true;
    }, 0);
  }

  updateServiceType(type) {
    if(this.isPublicProfile){
    this.serviceTypeControl.setValue(type)

    }else {
      this.showOtherServiceSlots(type)
    }
  }

  checkForSpecialtyChange() {
    this.specialityFormControl.valueChanges
      .subscribe(
        (value => {
          this.onSpecialtyChange.emit({ specialtyId: value, doctorId: this.doctor.userId });
          setTimeout(() => {
            // this.timeTableWrapper.nativeElement.style.right = 0 + 'px';
            this.canSlideLeft = false;
            this.canSlideRight = true;
          }, 0);
        })
      );
  }

  getDoctorTimeSlots(serviceTypeId: number, searchDate?: number): Observable<any> {
    let lastSlotTimes = [];
    for (let slot in this.doctor.timeSlotDTOs) lastSlotTimes.push(Number(slot));
    let maxTime = lastSlotTimes[0];
    if (!searchDate) {
      lastSlotTimes.forEach(slot => {
        if (maxTime > slot) {
          maxTime = slot;
        }
      });
    } else {
      maxTime = searchDate;
    }
    this.canSlideRight = true;
    this.loadingService.setApplicationLoading(true);
    let params = new HttpParams();
    params = params.append('SpecialtyId', this.specialityFormControl.value);
    params = params.append('DoctorId', this.doctor.userId.toString());
    params = params.append('SlotDateFrom', maxTime);
    params = params.append('ServiceTypeId', serviceTypeId.toString());
    params = params.append('Days', '4');
    if (this.doctor.clinic) {
      params = params.append('clinic-id', this.doctor.clinic.id.toString());
    }
    return this.API.searchDoctorsSlotsForSpec(params)
      .pipe(
        map((response: any[]) => {
          this.loadingService.setApplicationLoading(false);
          this.canSlideRight = true;
          for (let slot in response[0].timeSlotDTOs) {
            if (response[0].timeSlotDTOs[slot].length < 5) {
              const slotLength = response[0].timeSlotDTOs[slot].length;
              for (let i = 0; i < 5 - slotLength; i++) {
                response[0].timeSlotDTOs[slot].push({
                  slotDate: null,
                  slotId: null,
                  specialtyId: this.selectedSpeciality,
                  timeString: '-'
                });
              }
            }
          }
          this.doctor = {...response[0]}
          this.doctorUpdated.emit(response[0])
          this.cdr.detectChanges();
          return response;
        }),
        catchError(error => {
          this.loadingService.setApplicationLoading(false);
          return throwError(error);
        }));
  }

  disableNextButton() {
    this.canSlideRight = false;
  }

  public showMoreSlots(): void {
    this.toggleSlots = !this.toggleSlots;
    if (this.toggleSlots) {
      this.allSlots = 10000;
    } else {
      this.allSlots = 5;
    }
  }

  startOrder(timeSlot: TimeSlot, serviceType?) {

    if (!timeSlot.slotId) {
      return;
    }
    const isDoctra = this.doctor.isDoctra;
    let hasInsurance = false;
    this.route.queryParamMap.subscribe((params) => {
      const insuranceParam = params.get('insurance');
      hasInsurance = insuranceParam === 'true';
    })
    const sendData: any = {
      DoctorId: this.doctor.userId,
      TimeSlotId: timeSlot.slotId,
      ServiceTypeId: serviceType ? serviceType : this.selectedServiceType,
      SpecialityId: timeSlot.specialtyId,
      doctorId: this.doctor.userId,
      serviceTypeId: serviceType ? serviceType : this.selectedServiceType,
      specialtyId: timeSlot?.specialtyId,
      clinicId: this.doctor?.clinic?.id,
      timeSlot: timeSlot?.timeUnix
    };
    if (!this.currentUser) {
      this.router.navigate([`/user/auth-user`])
        .then(
          () => {
            localStorage.setItem('preOrder', JSON.stringify(sendData));
            PageManipulationUtilsService.scrollToTop();
          }
        );
      return;
    }
    this.loadingService.setApplicationLoading(true);
    let doctor =false;
    if (this.route.snapshot.queryParamMap.has('doctor')){
      doctor = true;
    }
    this.API.createOrder(sendData, isDoctra, hasInsurance, doctor)
      .subscribe(
        (response: any) => {
          let queryParams: any = {
            orderId: response.OrderId,
            doctorId: sendData?.DoctorId || sendData?.doctorId,
            ServiceTypeId: serviceType ? serviceType : this.selectedServiceType,
            SpecialityId: this.specialityFormControl.value,
            clinicId: this.doctor?.clinic?.id
          }

          if (hasInsurance) {
            queryParams = {
              orderId: response.OrderId,
              doctorId: sendData?.DoctorId || sendData?.doctorId,
              ServiceTypeId: serviceType ? serviceType : this.selectedServiceType,
              SpecialityId: this.specialityFormControl.value,
              clinicId: this.doctor?.clinic?.id,
              insurance: true,
            }

            if (doctor) {
              queryParams.doctor = true;
            }
          }
          if(hasInsurance) {
            this.router.navigate([`/order-with-insurance`], {
              queryParams
            }).then(() => {
              this.loadingService.setApplicationLoading(false);
            });
          } else {
            this.router.navigate([`/order`], {
              queryParams
            }).then(() => {
              this.loadingService.setApplicationLoading(false);
            });
          }
        }, (error: HttpErrorResponse) => {
          this.loadingService.setApplicationLoading(false);
          if (!this.Auth.isLogged()) {
            return;
          } else {
            alert(this.translateService.instant('an-error-occurred-while-placing-the-order'));
          }
        });
  }

  public initServiceTypes(id?: string) {
    this.API.getServiceType1(id).subscribe(
      res => {
        if (res) {
          if (res.hasOwnProperty('result')) {
            this.serviceTypes = res['result'];
            if (this.selectedServiceType) {
              this.serviceTypeControl.setValue(this.selectedServiceType, { emitEvent: false });
            }
            else {
              this.serviceTypeControl.setValue(this.serviceTypes[0]?.key, { emitEvent: false });
              this.serviceTypeControl.updateValueAndValidity();
            }
            if (this.selectedSpeciality) {
              this.specialityFormControl.setValue(this.selectedSpeciality, { emitEvent: false });
            }
          }
          // this.dataInitialized = true;
        }
      }, error => {
        // this.Auth.checkAccess(error);
      }
    );
  }

  showOtherServiceSlots(serviceTypeId: number) {
    if (serviceTypeId === this.selectedServiceType) {
      return;
    }
    this.selectedServiceType = serviceTypeId
    this.getDoctorTimeSlots(serviceTypeId)
      .subscribe(
        (response: any) => {
          this.doctorSlotsAvailable = false
          let slotsAvailable = false;
          for (let slot in response[0].timeSlotDTOs) {
            response[0].timeSlotDTOs[slot].forEach(timeSlot => {
              if (timeSlot.slotId) {
                slotsAvailable = true;
              }
            });
          }
          // const dialog = this.dialog.open(DoctorSlotDialogComponent, {
          //   data: {
          //     doctor: response[0],
          //     serviceTypeId: serviceTypeId,
          //     slotsAvailable: slotsAvailable
          //   },
          //   width: '500px',
          //   height: '530px'
          // });
          // dialog.componentInstance.onDateChange
          //   .subscribe((searchDate: number) => {
          //     this.getDoctorTimeSlots(serviceTypeId, searchDate)
          //       .subscribe((otherSlots: any) => {
          //         let slotsAvailable = false;
          //         for (let slot in otherSlots[0].timeSlotDTOs) {
          //           otherSlots[0].timeSlotDTOs[slot].forEach(timeSlot => {
          //             if (timeSlot.slotId) {
          //               slotsAvailable = true;
          //             }
          //           });
          //         }
          //         dialog.componentInstance.data = {
          //           doctor: otherSlots[0],
          //           serviceTypeId: serviceTypeId,
          //           slotsAvailable: slotsAvailable
          //         };
          //       });
          //   });
          // dialog.afterClosed()
          //   .subscribe(
          //     (timeSlot => {
          //       if (timeSlot) {
          //         this.startOrder(timeSlot, serviceTypeId);
          //       }
          //     })
          //   );
        });
  }

  requestDoctor($event: MouseEvent) {
    if (this.doctorRequested) return;
    if (this.currentUser) {
      const data = {
        DoctorId: this.doctor.userId,
        SpecialtyId: this.specialityFormControl.value,
        ServiceTypeId: this.selectedServiceType,
        SearchDate: Object.keys(this.doctor.timeSlotDTOs)[0]
      };
      this.doctorService.requestDoctor(data)
        .subscribe(
          (response: any) => {
            const dialog = this.dialog.open(RequestDoctorDialogComponent, {
              width: '430px',
              data: data
            });
            dialog.afterClosed()
              .subscribe((result: any) => {
                if (result.getData) {
                  this.router.navigate(['/search'], {
                    queryParams: {
                      specId: data.SpecialtyId,
                      serviceType: data.ServiceTypeId
                    }
                  }).then(() => {
                    this.reinitializeSearch.emit({
                      specId: data.SpecialtyId,
                      serviceType: data.ServiceTypeId
                    });
                    PageManipulationUtilsService.scrollToTop();
                  });

                } else if (result.wait) {
                  this.doctorRequested = true;
                  this.doctor.doctorRequested = true;
                  this.doctor.canBeRequested = false;
                  ($event.target as HTMLButtonElement).click();
                }
              });
          });
    } else {
      const doctorRequestData = {
        DoctorId: this.doctor.userId,
        SpecialtyId: this.specialityFormControl.value,
        ServiceTypeId: this.selectedServiceType,
        SearchDate: Object.keys(this.doctor.timeSlotDTOs)[0]
      };
      this.router.navigate([`/user/auth-user`])
        .then(
          () => {
            localStorage.setItem('doctorRequestData', JSON.stringify(doctorRequestData));
            PageManipulationUtilsService.scrollToTop();
          });
    }
  }

  goToSelectedDate(closestDate: number) {
    if (this.isPublicProfile) {
      this.searchDateChange.emit(closestDate);
      return;
    }
    this.navigateToClosestAvailableDate.emit({ specialtyId: this.specialityFormControl.value, date: closestDate, keyword: this.doctor.userId });
  }

  checkForBackwardDisable() {
    return moment(this.getMinDate()).isSameOrBefore(new Date(), 'day');
  }

  checkForNextDisable() {
    return moment(this.getMinDate()).isSameOrAfter(this.maxDate, 'day');
  }

  getMinDate(): number {
    let minDate = Number(Object.keys(this.doctor.timeSlotDTOs)[0]);
    for (const date in this.doctor.timeSlotDTOs) {
      if (Number(date) < minDate) {
        minDate = Number(date);
      }
    }
    return minDate;
  }

  searchNextDate(next: boolean) {
    const currentDate = moment(this.getMinDate());
    const addableDays = this.isPublicProfile ? 3 : 4;
    if (next) {
      currentDate.add(addableDays, 'day');
    } else {
      const currentSearchDay = currentDate;
      const today = moment().add(addableDays, 'day');
      if (today.isSameOrBefore(currentSearchDay)) {
        currentDate.subtract(addableDays, 'day');
      } else {
        const daysToSubtract = currentSearchDay.date() - today.date() + addableDays;
        currentDate.subtract(daysToSubtract, 'day');
      }
    }
    this.searchDateChange.emit(currentDate.valueOf());
  }

  checkUserCountry(timeSlot: TimeSlot) {
    localStorage.removeItem('foreignerSlotsPageRoute');
    if (!timeSlot.slotId) {
      return;
    }
    if (Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Tbilisi' || new Date().getTimezoneOffset() / 60 === -4) {
      this.startOrder(timeSlot);
      return;
    }
    else if (!this.currentUser) {
      localStorage.setItem('foreignerSlotsPageRoute', this.router.url);
      this.startOrder(timeSlot);
      return;
    }

    const d = new Date();
    const utc = d.getTime() + (d.getTimezoneOffset() * 60000);
    const nd = new Date(utc + (3600000 * (+4)));
    const tbilisiTime = nd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    const date = new Date(`2021/05/05 ${timeSlot.timeString}:00 +0400`);
    const currentDate: any = new Date(date.getTime() - new Date().getTimezoneOffset() * 60000).toISOString().substring(11, 16);

    const message = `ყურადღება! გთხოვთ გაითვალისწინოთ, რომ ექიმთან კონსულტაციაზე ჩასაწერად ვებ-გვერდზე მითითებული საათები მოცემულია თბილისის დროით (GMT +04:00). ახლა თბილისში ${tbilisiTime} საათია, შესაბამისად თქვენი დროით კონსულტაცია დაიწყება ${currentDate} საათზე.`;

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '816px',
      data: {
        message,
        customClass: 'text-dark'
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe((res => {
      if (res) {
        this.startOrder(timeSlot)
      }
    }))
  }

  private setInsuranceStatus(): void {
    this.isInsuranceBubble = this.route.snapshot.queryParamMap.has('insurance');
  }

}